import { Component, EventEmitter, Input, Output, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { createEditor, createToolbar, IDomEditor, IEditorConfig, IToolbarConfig, Toolbar } from '@wangeditor/editor';

export type NcModeType = 'default' | 'simple';

@Component({
  selector: 'nc-editor',
  templateUrl: './editor.component.html',
  styleUrls: [
    './editor.component.less',
    '../../../node_modules/@wangeditor/editor/dist/css/style.css'
  ],
  encapsulation: ViewEncapsulation.None
})
export class EditorComponent implements AfterViewInit {
  /** 编辑器模式 */
  @Input() ncEditorMode: NcModeType = 'default';
  /** 工具栏模式 */
  @Input() ncToolbarMode: NcModeType = 'default';
  /** 编辑器配置 */
  @Input() ncEditorConfig: Partial<IEditorConfig> = {};
  /** 工具栏配置 */
  @Input() ncToolbarConfig: Partial<IToolbarConfig> = {};
  /** 初始化内容 */
  @Input() ncHtml: string = '<p><br></p>';
  /** 编辑器容器id */
  @Input() ncDomId: string = 'nc-editor';
  /** 编辑器加载完成事件 */
  @Output() ncLoaded = new EventEmitter<{ editor: IDomEditor, toolbar: Toolbar }>();

  editor!: IDomEditor;
  toolbar!: Toolbar;

  constructor() { }

  ngAfterViewInit(): void {
    //默认工具栏配置
    const toolbarConfig: Partial<IToolbarConfig> = {
      excludeKeys: ['group-video', 'insertImage']
    }

    //默认菜单栏和编辑器配置
    const editorConfig: Partial<IEditorConfig> = {
      //菜单栏配置
      MENU_CONF: {
        uploadImage: {
          server: '',
          base64LimitSize: 10 * 1024 * 1024
        }
      },
      //编辑器配置
      placeholder: '请输入内容...'
    }

    this.editor = createEditor({
      selector: `#${this.ncDomId}-editor`,
      html: this.ncHtml,
      config: Object.assign({}, editorConfig, this.ncEditorConfig),
      mode: this.ncEditorMode
    })

    this.toolbar = createToolbar({
      editor: this.editor,
      selector: `#${this.ncDomId}-toolbar`,
      config: Object.assign({}, toolbarConfig, this.ncToolbarConfig),
      mode: this.ncToolbarMode
    })

    // console.log(Object.assign({}, editorConfig, this.ncEditorConfig));
    // console.log(Object.assign({}, toolbarConfig, this.ncToolbarConfig));
    // console.log(this.editor.getAllMenuKeys());
    console.log(this.toolbar.getConfig().toolbarKeys);

    this.ncLoaded.emit({ editor: this.editor, toolbar: this.toolbar });
  }

  ngOnDestroy(): void {
    this.editor.destroy();
    this.toolbar.destroy();
  }
}
